import * as HelperStorage from '../../../helpers/helper-storage'

const authGuard = (to: any, from: any, next: any) => {
  if (to.meta.auth) {
    const isConnected = HelperStorage.get('connected')
    if (isConnected) {
      next()
    } else {
      next.redirect('/signin')
    }
  } else {
    next()
  }
}

export default authGuard
